import { Link, usePage } from "@inertiajs/react"
import type { PropsWithChildren } from "react"

import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { cn } from "@/lib/utils"
import { adminSettingsProfilePath, adminSettingsUsersPath } from "@/routes"
import type { NavItem } from "@/types"

const sidebarNavItems: NavItem[] = [
  {
    title: "Members",
    href: adminSettingsUsersPath(),
    icon: null,
  },
  {
    title: "Profile",
    href: adminSettingsProfilePath(),
    icon: null,
  },
]

export default function AdminSettingsLayout({ children }: PropsWithChildren) {
  const { url } = usePage()

  return (
    <div className="px-4 py-6">
      <div className="flex flex-col space-y-8 lg:flex-row lg:space-y-0 lg:space-x-12">
        <aside className="w-full max-w-xl lg:w-48">
          <nav className="flex flex-col space-y-1 space-x-0">
            {sidebarNavItems.map((item, index) => (
              <Button
                key={`${item.href}-${index}`}
                size="sm"
                variant="ghost"
                asChild
                className={cn("w-full justify-start", {
                  "bg-muted": url === item.href,
                })}
              >
                <Link href={item.href}>
                  {item.icon && <item.icon className="h-4 w-4" />}
                  {item.title}
                </Link>
              </Button>
            ))}
          </nav>
        </aside>

        <Separator className="my-6 md:hidden" />

        <div className="flex-1 md:max-w-2xl">
          <section className="max-w-xl space-y-12">{children}</section>
        </div>
      </div>
    </div>
  )
}
